import { Box } from '@mui/material';
import { PageContainer, PageTitle } from 'components/Structure';
import { usePageTitle } from 'components/hooks';
import { Tabs } from 'designSystem';
import { ITab } from 'designSystem/Primitives/Tabs/Tabs';
import React, { FC } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';

type TabType = 'due-diligence-progress' | 'risk-results';

enum ComplianceTabKey {
  DUE_DILIGENCE_PROGRESS = 'due-diligence-progress',
  RISK_RESULTS = 'risk-results',
}

const COMPLIANCE_TABS: ITab<ComplianceTabKey>[] = [
  {
    key: ComplianceTabKey.DUE_DILIGENCE_PROGRESS,
    label: 'Due diligence progress',
  },
  //   {
  //     key: ComplianceTabKey.RISK_RESULTS,
  //     label: 'Risk results',
  //   },
];

const ComplianceOverviewLayout: FC = () => {
  usePageTitle('Compliance Overview');

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const selectedTab: TabType = pathname.split('/')[3] as TabType;

  const handleChangeTab = (tab: ComplianceTabKey) => {
    if (tab === ComplianceTabKey.DUE_DILIGENCE_PROGRESS) {
      navigate(`/compliance/eudr/due-diligence-progress`);
    } else {
      navigate(`/compliance/eudr/risk-results`);
    }
  };

  return (
    <PageContainer>
      <Box display="flex" alignItems="center">
        <PageTitle title="Compliance overview" titleExtension="EUDR" />
      </Box>

      <Box mt={3} mb={1}>
        <Tabs
          tabs={COMPLIANCE_TABS}
          selectedTab={selectedTab as ComplianceTabKey}
          onChange={handleChangeTab}
        />
      </Box>

      <Outlet />
    </PageContainer>
  );
};

export default ComplianceOverviewLayout;
